import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./features.css";

const FeatureData = [
  {
    title: "Python тіліндегі модул",
    desc: "Python тіліндегі модул - бұл басқа бағдарламаларда қайта пайдалануға болатын жеке код файлы. Модуль құру үшін *. py кеңейтілімімен жеке файл  құру қажет. Файл атауы модульдің атын білдіреді.",
    icon: "ri-bar-chart-2-fill",
  },

  {
    title: "Бағдарлама құрамы",
    desc: "Бағдарлама құрамы өсіп келе жатқанда, оны сақтауды жеңілдету үшін оларды бірнеше файлға бөлу қажет болады. Бағдарламалардың әрқайсысына олардың анықтамаларын көшірместен бірнеше бағдарламаларда жазылған функцияларды қайта пайдалану қажет болуы мүмкін.",
    icon: "ri-registered-fill",
  },

  {
    title: "Python кластар, функциялар",
    desc: "Python кластарды, функцияларды немесе деректерді бөлек файлға салуға және оларды басқа бағдарламаларда пайдалануға мүмкіндік береді. Мұндай файл модуль деп аталады. Модульдегі объектілерді басқа модульдерге импорттауға болады.",
    icon: "ri-cloud-fill",
  },
];

const Features = () => {
  return (
    <section>
      <Container>
        <Row>
          {FeatureData.map((item, index) => (
            <Col lg="4" md="6" key={index}>
              <div className="single__feature text-center px-4">
                <h2 className="mb-3">
                  <i class={item.icon}></i>
                </h2>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
